
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class EmployeeCardTag extends Vue {
    @Prop({ type: String, required: true }) readonly tagName!: string;
  }
